import React, { useEffect, useMemo, useState } from 'react'
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom'
import { api } from '../../../app/Api/ApiSlice'
import { toast } from 'react-toastify'
import { FaComment, FaInfoCircle, FaThumbsUp } from 'react-icons/fa'
import moment from 'moment'
import officeImg from "../../../assets/office.png"
import UserImage from "../../../assets/user.png"
import CountrySelect from '../../../components/CountrySelect'
import { Country } from 'country-state-city'

const CreatePostAd = () => {
    const navigate = useNavigate()
    const location = useLocation()

    const { organization } = useParams()

    // Guard against direct navigation without state
    const { ad = null, adType = 'Post' } = location.state || {}

    // Normalize media sources (bug fix: files vs filesUrls)

    const [focusedImg, setFocusedImg] = useState(ad?.files[0] || null)
    const [allCountries, setAllCountries] = useState([]);
    const [selectedCountries, setSelectedCountries] = useState([]);
    const [budget, setBudget] = useState(1000)
    const [startDate, setStartDate] = useState("")
    const [endDate, setEndDate] = useState("")
    const [audience, setAudience] = useState("general")
    const [isSubmitting, setIsSubmitting] = useState(false)

    useEffect(() => {
        setFocusedImg(ad.files[0] || null)
    }, [ad])

    const today = new Date().toISOString().split("T")[0];

    useEffect(() => {
        setAllCountries(Country.getAllCountries().map(c => ({ value: c.isoCode, label: c.name })));
    }, []);

    const toggleCountry = (country) => {
        const exists = selectedCountries.some(c => c.value === country.value);
        if (exists) return setSelectedCountries(prev => prev.filter(c => c.value !== country.value));
        setSelectedCountries(prev => [...prev, country]);
    };

    useEffect(() => {
        if (!startDate || !endDate) return;

        const start = new Date(startDate);
        const end = new Date(endDate);

        if (end < start) return;

        const days =
            Math.ceil((end - start) / (1000 * 60 * 60 * 24)) + 1;

        setBudget(days * 250);
    }, [startDate, endDate]);


    const handleSubmit = async (e) => {
        e.preventDefault()

        if (!budget) {
            toast.error('Daily budget is required')
            return
        }

        try {
            setIsSubmitting(true)

            const response = await api.post(`/${organization}/manage/promotions/posts`,
                { postId: ad._id, selectedCountries, budget, audience, startDate, endDate })
            if (!response) {
                toast.error('Ad not saved. Please try again.')
                return
            }
            toast.success('Ad saved please pay to activate it')
            navigate(`/${organization}/admin/promotions/${response.data.ad._id}/payments`, { state: { ad: response.data.ad } })
        } catch (error) {
            // console.log(error)
            toast.error(error?.response?.data?.message || 'Ad not saved')
        } finally {
            setIsSubmitting(false)
        }
    }

    if (!ad) {
        return <div className="create-ad-page"><p>Invalid ad context.</p></div>
    }

    return (
        <div className="">
            <div className="create-ad-title">
                <h3>Promote This {adType}</h3>
            </div>
            <div className="create-ad-page">

                <form onSubmit={handleSubmit} className="create-ad-form">
                    <div className="ad-content">
                        <div className='post'>
                            <div className='org-post'>
                                <div className="org-post-header">
                                    <div className="profile-details">
                                        <img
                                            src={ad.organization?.profileImage || officeImg}
                                            alt="organization"
                                            className="userpost-profile-img"
                                        />
                                        <div className="post-data-details">
                                            <p className="post-profile-name">{ad?.organization?.name}</p>
                                            <div className="post-dates">
                                                <p>{moment(ad.createdAt).fromNow()}</p>
                                                <p>Audience</p>
                                            </div>
                                        </div>
                                    </div>
                                    {/* <FaEllipsisV /> */}
                                    {ad.createdBy?._id && (
                                        <Link to={`/user/${ad.createdBy._id}`}>
                                            <div className="org-post-user">
                                                <div className="org-post-userimg">
                                                    <img src={ad.createdBy?.profilePic || UserImage} alt='' />
                                                </div>
                                                <div className="org-post-username">
                                                    <h3>{ad.createdBy?.firstname} {ad.createdBy?.lastname}</h3>
                                                </div>
                                            </div>
                                        </Link>
                                    )}
                                </div>

                                <div className="post-body">
                                    {ad.postText && (
                                        <div className="text">
                                            <p>{ad.postText.substring(0, 100)}</p>
                                        </div>
                                    )}

                                    {ad.files.length > 0 && (
                                        <div className="postcard-images">
                                            {ad.files[0].type === 'image' && focusedImg && (
                                                <div className="post-images">
                                                    <div className="focused-image">
                                                        <img src={focusedImg.url} alt="focused" />
                                                    </div>
                                                    <div className="image-list">
                                                        <div className='image-selector'>
                                                            {ad.files.map((image, i) => (
                                                                <div
                                                                    className='image-selector-wrapper'
                                                                    key={i}
                                                                    onClick={() => setFocusedImg(image)}>
                                                                    <img src={image.url} alt="thumb" />
                                                                </div>
                                                            ))}
                                                        </div>
                                                    </div>
                                                </div>
                                            )}

                                            {ad.files[0].type === 'video' && (
                                                <div className='video-container'>
                                                    <video controls>
                                                        <source src={ad.files[0]} type='video/mp4' />
                                                    </video>
                                                </div>
                                            )}
                                        </div>
                                    )}
                                </div>

                                <div className="post-footer">
                                    <div className="post-footer-icon"><FaThumbsUp /><p>{ad.likesCount || 0}</p></div>
                                    <div className="post-footer-icon"><FaComment /><p>{ad.commentsCount || 0}</p></div>
                                    <div className="post-footer-icon"><FaInfoCircle /></div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="form-group">
                        <label>Dates *</label>
                        <p>start</p>
                        <input
                            type="date"
                            name="startDate"
                            min={today}
                            value={startDate}
                            required
                            onChange={(e) => {
                                const value = e.target.value;
                                setStartDate(value);
                                if (endDate && endDate < value) {
                                    setEndDate(value);
                                }
                            }}
                        />

                        <p>end</p>
                        <input
                            type="date"
                            name="endDate"
                            required
                            min={startDate || today}
                            value={endDate}
                            onChange={(e) => setEndDate(e.target.value)}
                        />

                    </div>

                    <div className="form-group">
                        <label>Target Audience</label>
                        <select name="audience" value={audience} onChange={(e) => setAudience(e.target.value)}>
                            <option value="general">General</option>
                            <option value="youth">Youth</option>
                            <option value="professionals">Professionals</option>
                            <option value="business">Business</option>
                        </select>
                        <div className="country">
                            <CountrySelect />
                        </div>
                        <div className="countries">
                            {allCountries.map(c => (
                                <button type="button" key={c.value} className={selectedCountries.some(s => s.value === c.value) ? "country active" : "country"} onClick={() => toggleCountry(c)}>
                                    {c.label}
                                </button>
                            ))}
                        </div>
                    </div>

                    <div className="payment-section">
                        <h4>Payment</h4>
                        <p className="payment-summary">Amount to be charged: <strong>Ksh{Number(budget) || 0}</strong></p>
                    </div>

                    <div className="form-actions">
                        <button type="submit" disabled={isSubmitting}>
                            {isSubmitting ? 'Processing...' : 'Save'}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    )
}

export default CreatePostAd
